import React from 'react';
import * as Sentry from '@sentry/react';
import styled from 'styled-components';

const FallbackPanel = styled.div`
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  border-left: 4px solid var(--accent-color);
  border-radius: 12px;
  box-shadow: 0 18px 45px rgba(78, 58, 10, 0.14);
  margin: 2rem auto;
  max-width: 560px;
  padding: 1.5rem;
  text-align: center;

  p {
    color: var(--muted-text-color);
  }

  button {
    background: var(--accent-color);
    border: 1px solid var(--accent-color);
    border-radius: 999px;
    color: var(--text-color);
    font-weight: 700;
    min-height: 40px;
    padding: 0.45rem 1.1rem;
  }

  button:hover,
  button:focus {
    background: var(--accent-hover-color);
    border-color: var(--accent-hover-color);
  }
`;

const FallbackComponent = ({ resetError }) => (
  <FallbackPanel>
    <h2>Something went wrong</h2>
    <p>The solar calculator encountered an error. Please refresh the page.</p>
    <button onClick={resetError}>Try again</button>
  </FallbackPanel>
);

const SentryErrorBoundary = ({ children }) => (
  <Sentry.ErrorBoundary fallback={FallbackComponent}>
    {children}
  </Sentry.ErrorBoundary>
);

export default SentryErrorBoundary;
